module.exports = __webpack_public_path__ + "media/application/images/2023/06_still-1250x703-6f4de304e8953fba2cc67429be22603e.png";